<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon-sections" width="18.003" height="13.993" viewBox="0 0 18.003 13.993"><g transform="translate(-856.03 -1025.534)"><path d="M856.491,1030.6l8.245,3.627a.748.748,0,0,0,.6,0l8.245-3.627a.75.75,0,0,0,0-1.373l-8.245-3.629a.747.747,0,0,0-.6,0l-8.245,3.629a.75.75,0,0,0,0,1.373Zm8.547-3.5,6.383,2.809-6.383,2.808-6.383-2.808Z" fill="#939393"/><path d="M872.967,1034.462h0l-7.943,3.5-7.942-3.5a.75.75,0,0,0-.6,1.373l8.245,3.629a.748.748,0,0,0,.6,0l8.245-3.629a.75.75,0,1,0-.605-1.372Z" fill="#939393"/></g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-sections'
  }
</script>
